export const ledgerbookActionTypes = {
    LEDGER_BOOK_LOADING: "LEDGER_BOOK__LOADING",
    LEDGER_BOOK__SUCCESS: "LEDGER_BOOK__SUCCESS",
    LEDGER_BOOK__ERROR: "LEDGER_BOOK__ERROR",
    LEDGER_BOOK__RESET: "LEDGER_BOOK__RESET",
  };
  